














































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Rss, RssContentDto, RssPostProperties, RssSortTypes } from "@/services/posts/postTypes/rss";
import { getRssItems } from "@/services/posts/postsService";
import RssRender from "@/components/posts/rss/RssRender.vue";
import { propertiesValidators } from "@/components/posts/rss/validators";
import { validateForm } from "@/services/validation/validationService";
import i18n from "@/i18n";
import vSelect from "vue-select";
import { RenderPostModel } from "@/services/render/types";
import { Style } from "@/services/styles/types";
import validate from "@/directives/validate";

@Component({
    components: {
        vSelect,
        RssRender
    },
    directives: {
        validate
    }
})
export default class RssForm extends Vue {
    @Prop() private properties!: RssPostProperties;
    @Prop() defaultShowTime!: number;
    @Prop() channelWidth!: number;
    @Prop() channelHeight!: number;
    // local state
    localProperties = {} as RssPostProperties;
    validators = propertiesValidators;
    rss = {} as Rss;
    scale = 0;
    style = {
        id: "",
        name: "",
        postType: "",
        css: {
            itemdescription: {},
            channeldescription: {},
            channeltitle: {},
            itemtitle: {}
        }
    } as Style;

    active = 0;

    // lifecycle hooks
    mounted() {
        this.localProperties = this.properties;
        this.setDefaultValues();
        this.setScale();
    }

    // watchers
    @Watch("defaultShowTime")
    onDefaultShowTimeChanged() {
        if (this.localProperties.showTime) return;
        this.$set(this.localProperties, "showTime", this.defaultShowTime);
    }

    @Watch("localProperties.url")
    onUrlChange() {
        this.getRssContnet();
    }

    @Watch("localProperties.rankStart")
    onRankStartChange() {
        if (this.localProperties.rankStart <= 0 || this.localProperties.rankStart > this.localProperties.rankEnd) return;
        this.getRssContnet();
    }

    @Watch("localProperties.rankEnd")
    onRankEndChange() {
        if (this.localProperties.rankEnd <= 0 || this.localProperties.rankEnd < this.localProperties.rankStart) return;
        this.getRssContnet();
    }

    @Watch("channelWidth")
    onChannelSizeChanged() {
        if (!this.channelWidth) return;
        this.setScale();
    }

    // methods
    sortTypes: any = Object.keys(RssSortTypes)
        .map(key => ({ name: i18n.t(`posts.rss.${key}`), id: key }));

    setDefaultValues() {
        this.localProperties.reloadTime = this.localProperties.reloadTime || 900;
        this.localProperties.rankStart = this.localProperties.rankStart || 1;
        this.localProperties.rankEnd = this.localProperties.rankEnd || 3;
        this.localProperties.sorting = this.localProperties.sorting || RssSortTypes.default;
        this.$nextTick(() => {
            this.$emit("setDefaultValues", JSON.stringify(this.localProperties));
        });
    }

    getRssContnet() {
        getRssItems(this.rssDto).then((data: Rss) => {
            this.rss = data;
            this.active++;
        });
    }

    async validateData() {
        return await validateForm([this.validators]);
    }

    emitData() {
        this.$emit("propertiesUpdated", this.localProperties);
    }

    setItemName() {
        var name = this.localProperties.url;
        this.$emit("itemNameUpdated", name);
    }

    setScale() {
        var scaleX = (window.innerWidth / 100 * 80) / this.channelWidth;
        var scaleY = (window.innerHeight / 100 * 64) / this.channelHeight;
        this.scale = scaleX <= scaleY ? scaleX : scaleY;
        this.scale = this.scale >= 1 ? 1 : this.scale;
    }

    // computed
    get previewModel() {
        return {
            id: "",
            settings: {},
            postType: "",
            properties: {
                showTime: this.localProperties.showTime,
                channelName: this.rss.channelName || "",
                channelDescription: this.rss.channelDescription || "",
                itemTitle: (this.rss.items.length > 0) ? this.rss.items[0].title : "",
                itemDescription: (this.rss.items.length > 0) ? this.rss.items[0].description : ""
            },
            css: {},
            styleId: "",
            channelId: "",
            channelName: "",
            name: "",
            originalId: ""
        } as RenderPostModel;
    }

    get rssDto(): RssContentDto {
        return {
            url: this.localProperties.url,
            rankStart: this.localProperties.rankStart,
            rankEnd: this.localProperties.rankEnd,
            sorting: this.localProperties.sorting
        };
    }

    get previewSize() {
        return {
            width: this.channelWidth * this.scale + "px",
            height: this.channelHeight * this.scale + "px"
        };
    }

    get getScale() {
        return {
            transform: "scale(" + this.scale + ")",
            "transform-origin": "top left"
        };
    }
}
